import axios from 'axios';

import PreguntaFrecuenteTabla from '../types/PreguntaFrecuenteTabla';


async function GuardarPreguntaFrecuente(prmPreguntaFrecuente: PreguntaFrecuenteTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_preguntafrecuente"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "preguntafrecuente": {
                "id": prmPreguntaFrecuente.id,
                "pregunta": prmPreguntaFrecuente.pregunta,
                "respuesta": prmPreguntaFrecuente.respuesta,
                "habilitado": prmPreguntaFrecuente.habilitado,
                "fch_modi": prmPreguntaFrecuente.fecha_modificacion,
                "dado_baja": prmPreguntaFrecuente.dado_de_baja,
                "fch_baja": prmPreguntaFrecuente.fecha_baja,
                "orden": prmPreguntaFrecuente.orden
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarPreguntaFrecuente;